import { z } from 'zod'
import { BlockTierSchema } from './block'

/**
 * Metadata for a single immutable published version of a block.
 *
 * Each block id has zero or more `BlockVersionMeta` rows (one per version)
 * plus at most one draft record. The gallery surfaces only the latest
 * published version per id; a version-history view enumerates all rows
 * via `listBlockVersions`.
 *
 * `name`, `tier`, `widthMm`, and `heightMm` are snapshots of the
 * `BlockDefinition` at promotion time, mirroring the snapshot semantics
 * of `BakedBlockInstance.expansion` / `BakedBlockInstance.placement`.
 */
export const BlockVersionMetaSchema = z.object({
  blockId: z.string(),
  version: z.number().int().positive(),
  name: z.string(),
  tier: BlockTierSchema,
  widthMm: z.number().positive(),
  heightMm: z.number().positive(),
  createdAt: z.string().datetime().optional(),
  createdBy: z.string().optional(),
})
export type BlockVersionMeta = z.infer<typeof BlockVersionMetaSchema>
